import { render, staticRenderFns } from "./cabinet-estates-list-cards-item-share.vue?vue&type=template&id=2f912e6d&scoped=true"
import script from "./cabinet-estates-list-cards-item-share.vue?vue&type=script&lang=js"
export * from "./cabinet-estates-list-cards-item-share.vue?vue&type=script&lang=js"
import style0 from "./cabinet-estates-list-cards-item-share.vue?vue&type=style&index=0&id=2f912e6d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f912e6d",
  null
  
)

export default component.exports